import '../styles/Home.css';
import { HOME_DATA } from '../constants/data';

function Home() {
  const { hero } = HOME_DATA;
  
  return (
    <section id="home" className="home-section">
      <div className="hero-content">
        <h1>{hero.welcome}<span dangerouslySetInnerHTML={{ __html: hero.title }} /></h1>
        <p>{hero.subtitle}</p>
        <button className="cta-button">
          <a href="#menu">{hero.cta}</a>
        </button>
        <button className="cta-button">
          <span onClick={() => window.open("https://www.instagram.com/tastyjunctionottawa/")}>{hero.offers}</span>
        </button>
      </div>
    </section>
  );
}

export default Home;
